import axios from "axios";
import CryptoJS from "crypto-js";
import API from "../config";
import { commonAxios } from "../.././src/pages/ExperianPage/CommonAxios";

const excludedRoutes = ["/login", "/sign-up", "/reset-password"];

function checkIsRefresh() {
  const navEntries = performance.getEntriesByType("navigation");
  return navEntries.length > 0 && navEntries[0].type === "reload";
}

const accessTokenAvailable = async (location) => {
  let invite = null;
  console.log(location, "loc30");
  const urlParams = new URLSearchParams(location.search);
  invite = urlParams.get("invite-code");
  const isRefresh = checkIsRefresh();
  if (isRefresh) {
    let response = await refreshSessionApi();
    if (response?.data?.accessToken) {
      localStorage.setItem("accessToken", response.data.accessToken);
    }
    if (response?.status === 419) {
      response = await refreshSessionApi(); // Retry once
    }
    if (response?.status === 440) {
      localStorage.clear();
      window.location.href = invite ? `/login?invite-code=${invite}` : "/login";
    }
  }
  // ✅ Add a listener without triggering a confirmation dialog
  const handleBeforeUnload = (e) => {
    // Do not set e.returnValue
  };
  window.addEventListener("beforeunload", handleBeforeUnload);
  // Return cleanup function (optional, if used inside useEffect)
  return () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
  };
};
const cloneAndConcat = (obj1, obj2, Origin) => {
  const safeClone = (obj) => JSON.parse(JSON.stringify(obj));
  let cloneObj1 = safeClone(obj1);
  let cloneObj2 = safeClone(obj2);
  const generateMD5 = (input) => {
    return CryptoJS.MD5(input).toString(CryptoJS.enc.Hex);
  };
  const convertEverythingToString = (data) => {
    if (Array.isArray(data)) {
      let arr = data
        .map(convertEverythingToString)
        .filter((item) => item !== null && item !== undefined);
      arr.sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
      return arr;
    } else if (data !== null && typeof data === "object") {
      let newObj = {};
      Object.keys(data)
        .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
        .forEach((key) => {
          const val = data[key];
          if (val !== null && val !== undefined) {
            newObj[key.toLowerCase()] = convertEverythingToString(val);
          }
        });
      return newObj;
    } else if (data !== null && data !== undefined) {
      return String(data).toLowerCase();
    } else {
      return undefined;
    }
  };
  const processedObj1 = convertEverythingToString(cloneObj1);
  const processedObj2 = convertEverythingToString(cloneObj2);
  let result =
    "@@@" +
    JSON.stringify(processedObj1) +
    "@@@" +
    JSON.stringify(processedObj2) +
    "@@@" +
    String(Origin).toLowerCase();
  result = encodeURIComponent(result);
  return generateMD5(result);
};

const refreshSessionApi = async () => {
  try {
    const response = await commonAxios(
      "/refresh",
      "POST",
      {},
      {
        // token: sessionKey,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};
const getApiData = async (
  url,
  method,
  params,
  data,
  headers,
  token,
  currentDate
) => {
  let headersValue = {
    ...headers,
  };

  let dataValue;
  if (method.toUpperCase() === "GET") {
    params = {
      ...params,
      currentTime: currentDate,
    };
  } else {
    // If data is FormData, don't inject currentTime directly
    if (data instanceof FormData) {
      data.append("currentTime", currentDate);
      dataValue = data;
      // Ensure content-type is handled by browser (remove manual JSON header)
      delete headersValue["Content-Type"];
    } else {
      dataValue = {
        currentTime: currentDate,
        ...data,
      };
      if (!headersValue["Content-Type"]) {
        headersValue["Content-Type"] = "application/json";
      }
    }
  }

  let urxValue;
  let x;
  try {
    urxValue = url.includes("experian")
      ? `${API.experianUrl}${url}`
      : `${API.apiUrl}${url}`;
    const accessToken = localStorage.getItem("accessToken");
    const loginToken = localStorage.getItem("loginToken");
    x = {
      url: urxValue,
      method,
      headers: {
        ...headersValue,
        authKey: token,
        Authorization: accessToken || loginToken,
      },
      params,
      data: dataValue,
      withCredentials: urxValue.includes("experian"),
    };

    const response = await axios(x);
    return response.data;
  } catch (error) {
    if (!excludedRoutes.includes(window.location.pathname)) {
      if (error?.status === 440) {
        localStorage.clear();
        let invite = null;
        const urlParams = new URLSearchParams(location.search);
        invite = urlParams.get("invite-code");
        window.location.href = invite
          ? `/login?invite-code=${invite}`
          : "/login";
      }
      if (error.status === 419) {
        let response = await refreshSessionApi();
        if (response?.data?.accessToken) {
          localStorage.setItem("accessToken", response?.data?.accessToken);
          localStorage.removeItem("loginToken");
          try {
            x = {
              url: urxValue,
              method,
              headers: {
                ...headersValue,
                authKey: token,
                Authorization: response?.data?.accessToken,
              },
              params,
              data: dataValue,
            };
            const responseFinal = await axios(x);
            return responseFinal.data;
          } catch (e) {
            console.error("Error refreshing session:", e);
          }
        }
      }
    }
    throw error;
  }
};

const CommonPathWay = async (
  url,
  method,
  params = {},
  data = {},
  headers = {}
) => {
  const [baseUrl, queryString] = url.split("?");
  const urlParams = new URLSearchParams(queryString || "");
  const currentDate = new Date().getTime();

  for (const [key, value] of urlParams.entries()) {
    if (!params[key]) {
      params[key] = value;
    }
  }

  if (method.toUpperCase() === "GET") {
    for (const [key, value] of Object.entries(data)) {
      if (!params.hasOwnProperty(key)) {
        params[key] = value;
      }
    }
    data = {};
  }

  // Handle FormData separately
  if (!(data instanceof FormData)) {
    if (method.toUpperCase() === "GET") {
      params = {
        ...params,
        currentTime: currentDate,
      };
    } else {
      data = {
        currentTime: currentDate,
        ...data,
      };
    }
  }

  const hashKey = cloneAndConcat(params, data, baseUrl);

  try {
    let token;
    return await getApiData(
      baseUrl,
      method,
      params,
      data,
      { ["X-Request-Signature"]: hashKey, ...headers },
      token,
      currentDate
    );
  } catch (error) {
    console.error("Error while processing:", error);
    throw error;
  }
};

export { CommonPathWay, refreshSessionApi, accessTokenAvailable };